/**
 * Geo-based automatic localization for the Relexy store.
 *
 * On a visitor's first visit, detects their country (provided by Shopify via IP)
 * and automatically switches to the matching language + currency:
 *
 *   Germany (DE)  →  German  (de)  +  EUR
 *   Spain   (ES)  →  Spanish (es)  +  EUR
 *   Canada  (CA)  →  English (en)  +  CAD
 *
 * Once a visitor manually changes their locale, the auto-switch never fires again.
 * The preference is stored in localStorage under CHOICE_KEY.
 */
(function () {
  'use strict';

  /** Key used to record whether the visitor has made a manual locale choice */
  var CHOICE_KEY = 'relexy_locale_user_choice';

  /**
   * Maps country ISO-codes to their preferred language ISO-codes.
   * Extend this object to add more geo rules.
   */
  var COUNTRY_TO_LANGUAGE = {
    // German-speaking countries
    DE: 'de',
    AT: 'de',
    CH: 'de',

    // Spanish-speaking countries
    ES: 'es',
    MX: 'es',
    AR: 'es',
    CO: 'es',
    CL: 'es',
    PE: 'es',
    VE: 'es',
    UY: 'es',
    EC: 'es',
    BO: 'es',
    PY: 'es',

    // English-speaking countries
    CA: 'en',
    US: 'en',
    GB: 'en',
    AU: 'en',
    NZ: 'en',
    IE: 'en',
    ZA: 'en',
  };

  // ── helpers ────────────────────────────────────────────────────────────────

  function readConfig() {
    return window.__geoLocalizationConfig || null;
  }

  function hasUserChosen() {
    try {
      return localStorage.getItem(CHOICE_KEY) === '1';
    } catch (_) {
      return false; // private-browsing may throw
    }
  }

  function recordUserChoice() {
    try {
      localStorage.setItem(CHOICE_KEY, '1');
    } catch (_) { /* silently ignore */ }
  }

  // ── form submission ────────────────────────────────────────────────────────

  function submitGeoForm(language, country) {
    var form       = document.getElementById('GeoLocalizationForm');
    var langInput  = document.getElementById('GeoLanguageInput');
    var countryInp = document.getElementById('GeoCountryInput');

    if (!form) return;

    if (langInput)  langInput.value  = language;
    if (countryInp) countryInp.value = country;

    // Tag the form so the submit-listener knows this is an auto-submit,
    // NOT a user-initiated action (so we don't lock in the choice prematurely).
    form.dataset.autoSubmit = 'true';
    form.submit();
  }

  // ── auto-switch ────────────────────────────────────────────────────────────

  function autoSwitch(config) {
    var detectedCountry    = config.detectedCountry;
    var currentLanguage    = config.currentLanguage;
    var availableLanguages = config.availableLanguages || [];

    if (!detectedCountry) return;

    var preferred = COUNTRY_TO_LANGUAGE[detectedCountry];

    if (!preferred) return;                              // country not in map
    if (preferred === currentLanguage) return;           // already correct
    if (availableLanguages.indexOf(preferred) === -1) return; // lang not enabled in store

    submitGeoForm(preferred, detectedCountry);
  }

  // ── track manual locale changes ────────────────────────────────────────────

  function trackManualChanges() {
    // Any form submit on a localization form = user is choosing their locale
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (
        form.id === 'LocalizationForm' ||
        form.id === 'GeoLocalizationForm'
      ) {
        if (!form.dataset.autoSubmit) {
          // This is a real user submission — lock their choice
          recordUserChoice();
        }
        // Clean up the flag regardless
        delete form.dataset.autoSubmit;
      }
    }, true);

    // Clicking a country option in the visible country-selector
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.localization-form__list-item')) {
        recordUserChoice();
      }
    });

    // Changing the language dropdown manually
    document.addEventListener('change', function (e) {
      if (
        e.target.name === 'language_code' &&
        e.target.closest &&
        e.target.closest('#LocalizationForm')
      ) {
        recordUserChoice();
      }
    });
  }

  // ── initialise ─────────────────────────────────────────────────────────────

  function init() {
    trackManualChanges();

    if (hasUserChosen()) return; // respect the visitor's explicit preference

    var config = readConfig();
    if (!config) return;

    autoSwitch(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
